/** V1 godown stock lookup, red-tie bags, replace a torn bag strings (English), spread into en.ts. Hindi: v1-stock.hi.ts. */
export const v1StockEn = {
  // What is where
  'store.v1.stock.title': 'What is where',
  'store.v1.stock.hint': 'Scan a **place label** or a **bag tag**',
  'store.v1.stock.scan': 'Scan a place or a bag',
  'store.v1.stock.orPick': 'Or pick a place',
  'store.v1.stock.onRoad': 'Vehicles on the road ({count})',
  'store.v1.stock.another': 'Look at another',
  'store.v1.stock.up': 'Back up',
  'store.v1.stock.count': 'Count here',
  'store.v1.stock.bagsWord': '{count:bag|bags}',
  'store.v1.stock.bagsN': '{count} {count:bag|bags}',
  'store.v1.stock.kg': '{kg} kg',
  'store.v1.stock.days': '{count} {count:day|days} here',
  'store.v1.stock.ready': 'Ready to send',
  'store.v1.stock.held': 'Stopped by the office',
  'store.v1.stock.noForm': 'Godown form not filled: these bags cannot be sent yet',
  'store.v1.stock.formEnds': 'Godown form ends in {count} {count:day|days}: fill it again',
  'store.v1.stock.lotsHere': 'Lots here',
  'store.v1.stock.onDockTitle': 'Unloaded, not yet in place',
  'store.v1.stock.dock': 'Unloaded, not in place',
  'store.v1.stock.empty': 'No bags here',
  'store.v1.stock.flagHeld': 'Stopped by the office',
  'store.v1.stock.flagRedTie': 'Red tie still to tie',
  'store.v1.stock.flagNotSent': 'Not sent yet',
  'store.v1.stock.flagProblem': 'Sending problem',
  'store.v1.stock.lot': 'Lot {lot}',
  'store.v1.stock.holdLot':
    'Stopped by the office: the bags stay where they are and **cannot be sent** until the supervisor allows',
  'store.v1.stock.where': 'Where the bags are',
  'store.v1.stock.missing': 'Missing',
  'store.v1.stock.onTrip': 'On vehicle {vehicle}',
  'store.v1.stock.elsewhere': 'Another place',
  'store.v1.stock.notHere':
    'This tag is not on this godown’s list. Update the list when there is internet.',
  'store.v1.stock.roadTitle': 'Vehicles on the road',
  'store.v1.stock.noRoad': 'No vehicle on the road',
  'store.v1.stock.from': 'Coming from {place}',
  'store.v1.stock.to': 'Going to {place}',

  // Red tie bags
  'store.v1.redTie.title': 'Red tie bags',
  'store.v1.redTie.none': 'No bag needs a red tie now',
  'store.v1.redTie.need': '{count} {count:bag needs|bags need} a red tie',
  'store.v1.redTie.tied': 'tied',
  'store.v1.redTie.how': 'Tie a **red tie** on the bag, then scan its tag',
  'store.v1.redTie.lot': '{lot} · {n}/{m} tied',
  'store.v1.redTie.newSacks': '{count} new {count:sack|sacks} (no proof)',
  'store.v1.redTie.notListed': 'This bag does not need a red tie',
  'store.v1.redTie.confirm': 'Red ties done',
  'store.v1.redTie.doneTitle': 'Red ties done',
  'store.v1.redTie.doneLine': '**{count}** {count:bag|bags} marked ordinary',
  'store.v1.redTie.moveNext': 'Now carry them to **{bay}** with "Move bags"',
  'store.v1.redTie.moveNextNoBay': 'Now carry them to the red-tie place with "Move bags"',

  // Torn bag
  'store.v1.replace.title': 'Torn bag',
  'store.v1.replace.countFirst': 'First **count the place** where the torn bag is: scan its label',
  'store.v1.replace.asked': 'Office asked {ago} ago',
  'store.v1.replace.countEvery': 'Scan the tag of **every bag** at this place',
  'store.v1.replace.counted': 'counted',
  'store.v1.replace.lotLine': '{lot} · {n}/{m}',
  'store.v1.replace.short': '{count} {count:bag|bags} short',
  'store.v1.replace.nothingHere': 'No bag is listed at this place',
  'store.v1.replace.notFromHere': '{count} {count:tag is|tags are} not from this place: {tags}',
  'store.v1.replace.countDone': 'Count done, next',
  'store.v1.replace.countSaved': 'Count saved',
  'store.v1.replace.recent': 'Bags changed earlier',
  'store.v1.replace.recentLine': 'Tag {old} → {new}',
  'store.v1.replace.lost': 'lost',
  'store.v1.replace.statusPending': 'Not sent yet',
  'store.v1.replace.statusReview': 'Kept aside: the supervisor will check',
  'store.v1.replace.statusOrphan':
    'Not proven: it is now **ordinary**. Tie a red tie, scan it, and move it to the red-tie place.',
  'store.v1.replace.statusError': 'Sending problem: open Sync',
  'store.v1.replace.lotShort': '{lot}: {count} short',
  'store.v1.replace.noShort': 'No lot is short here: the new sack will be **ordinary** grain',
  'store.v1.replace.old': 'Old tag',
  'store.v1.replace.oldNone': 'Only if it is still on the bag',
  'store.v1.replace.oldHint': 'Scan the **old tag** of the torn bag',
  'store.v1.replace.callSupervisor': 'Old tag lost: **call the supervisor**',
  'store.v1.replace.new': 'New tag',
  'store.v1.replace.newEmpty': 'From your own tag roll',
  'store.v1.replace.newHint': 'Scan a **new tag** from your roll',
  'store.v1.replace.sack': 'New sack',
  'store.v1.replace.sackWeight': 'Sack weighs {kg} kg',
  'store.v1.replace.weight': 'Weight with the sack',
  'store.v1.replace.weightEmpty': 'Type the weight',
  'store.v1.replace.weightHint': 'Put the new sack on the scale and type **what it shows**',
  'store.v1.replace.weightSave': 'Save weight',
  'store.v1.replace.kgUnit': 'kg',
  'store.v1.replace.net': 'Grain without sack',
  'store.v1.replace.gateNet': 'At the gate it was {kg} kg',
  'store.v1.replace.heavier': 'Heavier than the old bag: the supervisor will check',
  'store.v1.replace.candidate': 'Looks like tag {tag} of lot {lot} ({kg} kg)',
  'store.v1.replace.noCandidate':
    'No one bag matches ({count} possible): it will be ordinary grain',
  'store.v1.replace.photo': 'Photo of the new sack',
  'store.v1.replace.photoEmpty': 'Take a photo',
  'store.v1.replace.crop': 'Which crop?',
  'store.v1.replace.pick': 'Not picked',
  'store.v1.replace.pickBtn': 'Pick',
  'store.v1.replace.change': 'Change',
  'store.v1.replace.scan': 'Scan',
  'store.v1.replace.type': 'Type',
  'store.v1.replace.remove': 'Remove',
  'store.v1.replace.cutOld': '**Cut off the old tag** and keep it for the supervisor',
  'store.v1.replace.waitNew': 'Scan the new tag',
  'store.v1.replace.waitSack': 'Pick the sack',
  'store.v1.replace.waitWeight': 'Type the weight',
  'store.v1.replace.waitPhoto': 'Take the photo',
  'store.v1.replace.waitCrop': 'Pick the crop',
  'store.v1.replace.confirm': 'Change the bag',
  'store.v1.replace.doneTitle': 'Bag changed',
  'store.v1.replace.doneLine': 'New tag {tag}',
  'store.v1.replace.doneChip':
    'The new sack stays **kept aside** here until the supervisor checks it',
}

export type V1StockMessageKey = keyof typeof v1StockEn
